import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=5d0d080e&"
import script from "./empty.vue.ts?vue&type=script&lang=ts&"
export * from "./empty.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports